<template>
    <div class="md-layout-item md-medium-size-75 md-xsmall-size-100 md-size-50 p-2">
        <stats-card data-background-color="blue">
            <template slot="header">
                <md-icon>event</md-icon>
            </template>

            <template slot="content">
                <div class="loader" v-if="loading"></div>
                <div v-else>
                    <h5 class="category">{{ $t('registers.events.title') }}</h5>
                    <h4 class="title">{{count}}</h4>
                </div>
            </template>

            <template slot="footer">
                <div class="stats">
                    <md-icon class="text-success">details</md-icon>
                    <a href="#" @click.stop="goToEvents">{{ $t('seeMore')}}</a>
                    <!-- <button class="btn btn-link" >{{ $t('seeMore')}}</button> -->
                </div>
            </template>
        </stats-card>
    </div>
</template>

<script>
    import StatsCard from "../../../components/cards/StatsCard";
    import bus from '../../../components/sidemenu/event-bus';

    export default {

        props: {
            getValid: {
                type: Boolean,
                default: true
            },
            yearFilterValue: {
                type: [Number, String],
                default: 999
            }
        },
        components: {
            'stats-card': StatsCard
        },
        data() {
            return {
                loaded: false,
                loading: false,
                count: ''
            }
        },
        methods: {
            loadEventsCount() {
                this.loading = true;
                this.$http.get(this.getApiUrl(), { params: { yearSelectorValue: this.yearFilterValue } }).then(result => { // GetStructureWithValuesById
                    this.count = Number(result.data.eventsCount);
                }).catch(error => {

                }).then(() => {
                    this.loading = false;
                    this.loaded = true;
                });
            },
            goToEvents() {
                this.$router.push({ path: '/registers/events' });
            },
            getApiUrl() {
                if (this.getValid) {
                    return '/api/dynamicRegistersStatuses/ValidEventsCount';
                }
            },
            onEventAdded(id, eventName, eventCode) {
                this.loadEventsCount();
            },
            onEventUpdated(id, eventName, eventCode) {
                this.loadEventsCount();
            },
        },
        mounted() {
            this.loadEventsCount();

            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            isBgCulture() {
                return this.$store.getters.currentCulture === Culture.BG;
            }
        },
        watch: {
            yearFilterValue: function (val) {
                if (this.loaded) {
                    this.loadEventsCount();
                }
            }
        },
        created() {
            this.bus = bus;

            this.bus.$on('event-addded', this.onEventAdded);
            this.bus.$on('event-updated', this.onEventUpdated);
            this.bus.$on('event-deleted', this.onEventDeleted);
        },
        beforeDestroy() {
            // Make sure to cleanup SignalR event handlers when removing the component
            this.bus.$off('event-addded', this.onEventAdded);
            this.bus.$off('event-updated', this.onEventUpdated);
            this.bus.$off('event-deleted', this.onEventDeleted);
        },
    }
</script>
